import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["links", "columns", "classes", "namespace"],
    _excluded2 = ["key", "href", "hint", "children", "active", "menu", "onClick", "opened"];
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames/bind';
import { ButtonBase } from "../internal/ButtonBase";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import styles from './MenuLinks.css';
var cx = classNames.bind(styles);
var defaultClasses = {};

var MenuLinks = function MenuLinks(props) {
  var links = props.links,
      columns = props.columns,
      _props$classes = props.classes,
      classes = _props$classes === void 0 ? defaultClasses : _props$classes,
      namespace = props.namespace,
      rest = _objectWithoutProperties(props, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'menuLinks'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement("ul", _extends({}, rest, getTestId(), {
    className: cx('root', classes.root, {
      columns: columns
    })
  }), links.map(function (_ref, index) {
    var key = _ref.key,
        href = _ref.href,
        hint = _ref.hint,
        children = _ref.children,
        active = _ref.active,
        menu = _ref.menu,
        onClick = _ref.onClick,
        opened = _ref.opened,
        restItem = _objectWithoutProperties(_ref, _excluded2);

    var Link = function Link(restProp) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        React.createElement("a", _extends({}, restProp, {
          href: href
        }))
      );
    };

    var Button = function Button(restProp) {
      return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, restProp, {
        disabled: active && !menu
      }));
    };

    var Component = href ? Link : Button;
    return /*#__PURE__*/React.createElement("li", {
      key: key,
      className: cx('item')
    }, /*#__PURE__*/React.createElement(Component, _extends({}, restItem, getTestId(index.toString(), 'item'), {
      onClick: onClick,
      className: cx('link', classes.link)
    }), typeof children === 'function' ? children({
      opened: opened,
      active: active
    }) : children, hint && /*#__PURE__*/React.createElement("span", {
      className: cx('hint', classes.hint)
    }, hint)), menu && /*#__PURE__*/React.createElement(CSSTransition, {
      in: menu && opened,
      timeout: 200,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(MenuLinks, menu)));
  }));
};

export default MenuLinks;